import React, {Component} from 'react';
import { connect } from 'react-redux';
import { authOperations } from "../Login/state";
import Accordion from '../../components/Accordion';
import '../../../includes/custom/css/faq.css';

class FAQApp extends Component {
    
    componentDidMount() {
        this.props.setMobilePage("FAQ");
    }
    render(){
        var open = 3;
        return(
        <div>
            <h4 class="text-green text-bold pl-20">問い合わせ</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>   
                    <div label='通常の納品時間と異なる時間に納品をしてほしいのですが。'>
                        <p><a href="mailto:kos@kotokyoto.co.jp?subject=【ことねぎオーダーシステム】納品時間変更依頼&body=納品日：○月○日%0D%0A変更時間：○時○分%0D%0A店舗名：○○%0D%0A">こちらのメールフォーム</a>からご連絡をお願いいたします。<br/>
                        メールフォーム内の、「納品日」「変更時間」「店舗名」などを入力してください。</p>
                    </div>
                    <div label='問合せをしたいことがあるのですが。'>
                        <p><a href="mailto:kos@kotokyoto.co.jp?subject=【ことねぎオーダーシステム】問い合わせ&body=店舗名：○○">こちらのメールフォーム</a>からご連絡をお願いいたします。<br/>
                        「店舗名」の入力を忘れずにお願いいたします。</p>    
                    </div>
                </Accordion> 
            </div>

            
            <h4 class="text-green text-bold pl-20">ログイン画面</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>
                    <div label="パスワードを変更したいのですが。">
                        <p>ログイン画面にある「パスワード変更はこちら」から変更できます。</p>
                    </div>
                </Accordion>
            </div>

            <h4 class="text-green text-bold pl-20">発注全般</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>
                    <div label="発注内容をキャンセルしたいのですが。">
                        <p>発注数確定後は注文数0を入力して確定してください。</p>  
                    </div>
                    <div label="確定ボタンをタップするとエラー表示されてしまいますが、どうしたら良いですか。">
                        <p>商談時の注文条件に合っているか確認してください。<br/>
                        注文条件と異なる数量を入力すると、下記例のようなメッセージが表示されます。<br/>
                        ① 発注数量の倍数違い: 数量[7]が倍数[2]ではありません。<br/>
                        ② 最小注文数不足: 数量[1]が最小注文数[6]より小さいです。<br/>
                        ③ 最大注文数超過: 数量[21]が最大注文数[20]より大きいです。</p>
                    </div>
                    <div label="別の端末で変更した注文数が反映されていません。">
                        <p>ページの再読み込みをしてください。</p>
                    </div>
                    <div label="注文数が入力（変更）できないのですが。">
                        <p>注文締め時間を過ぎると入力（変更）不可になります。</p>  
                    </div>
                    <div label="注文数の文字の色の違いはなんですか。">
                        <p>初回入力数量は黒字で表示されます。<br/>
                        数量確定を行うと赤字に変わります。<br/>
                        こと京都側で修正を行った場合に背景が黄色に変わります。</p>
                    </div>
                </Accordion>
            </div>

            <h4 class="text-green text-bold pl-20">発注一覧（単日）</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>
                    <div label="入力していた内容が消えてしまったのですが。">
                        <p>発注数確定前に日付を変更すると、入力していた内容がキャンセルされます。<br/>
                        日付変更前に数量を確定させてください。</p>
                    </div>
                    <div label="過去（未来）の注文数を確認したいのですが。">
                        <p>納品日指定欄の◀（▶）をタップすると日付が変わります。<br/>
                        また日付をタップするとカレンダーが表示されるので、指定日を選択してください。</p>
                    </div>
                    <div label="数日分まとめて注文数を入力したいのですが。">
                        <p>商品名をタップすると、発注一覧（月間）に移行します。</p>
                    </div>
                </Accordion>
            </div>

            <h4 class="text-green text-bold pl-20">発注一覧（月間）</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>
                    <div label="前の画面（納品日別の注文画面）に戻りたいのですが。">
                        <p>右上の”ショッピングカート”ボタンか、左上の発注一覧（月間）の「＜」をタップしてください。</p>
                    </div>
                    <div label="発注数を変更したが確定ボタンがタップできません。">
                        <p>左のチェックボックスにチェックを入れると確定ボタンがタップできるようになります。<br/>
                        ※確定ボタンをタップしないと注文確定されないのでご注意ください。</p>
                    </div>
                    <div label="確定ボタンをタップしたが発注数が変更されません。">
                        <p>左のチェックボックスにチェックの入っていない日付の変更は行われず元の発注数が表示されます。<br/>
                        ※チェックが入っている日付分のみ変更されています。</p>
                    </div>
                    <div label="前（翌）月の注文数を確認したい。">
                        <p>月指定欄の◀（▶）をタップすると月が変更されます。</p>
                    </div>
                    <div label="入力していた内容が消えてしまったのですが。">
                        <p>発注数確定前に月を変更すると、入力していた内容がキャンセルされます。<br/>
                        月の変更前に数量を確定させてください。</p>
                    </div>
                </Accordion>
            </div>

            <h4 class="text-green text-bold pl-20">連絡配信</h4>
            <div class="panel-group">
                <Accordion allowMultipleOpen>
                    <div label="削除した連絡を再表示させたいのですが。">
                        <p>削除した案内は再表示できません。配信元に内容を確認してください。</p>
                    </div>
                    <div label="既（未）読にすると何が変わりますか。">
                        <p>既（未）読数が減ります。配信元には通知されません。</p>
                    </div>
                    <div label="連絡が未読、既読、削除されたかは配信元から分かりますか。">
                        <p>配信元では、配信先での状態は把握できません。</p>
                    </div>
                </Accordion>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
};

const mapDispatchToProps = {
    setMobilePage: authOperations.setMobilePage
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQApp);